import { Subject } from 'rxjs';

import type { RegularCall, TeamingRequest } from 'features/rns/interfaces';

export class EmergencyCallEventBus {
  static $newCall = new Subject<RegularCall>();
  static $newTeamingCall = new Subject<TeamingRequest>();
}
